// extracted by mini-css-extract-plugin
export default {"frame":"SMLPublishedThumb_frame__KLrbi","page":"SMLPublishedThumb_page__5Fonz","cover":"SMLPublishedThumb_cover__tdOPc"};